// src/utils/qzCompat.js
let qzLib = null;

export async function getQZ() {
  if (qzLib) return qzLib;
  try {
    const mod = await import('qz-tray');          // npm path
    qzLib = mod.default || mod;
    return qzLib;
  } catch (e) {
    if (typeof window !== 'undefined' && window.qz) {
      qzLib = window.qz;                          // CDN/global fallback
      return qzLib;
    }
    throw e;
  }
}
